// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4a28da8f","628":"c095ca32"}[chunkId] + ".chunk.js";
};